import { useEffect } from "react";
import { Row, Col } from "antd";
import { useLazyDashboardCountsQuery } from "../../redux/services/assignmentApi";
import ReportDownloadForm from "../Reports/ReportDownloadForm";
import { useAppSelector } from "../../redux/hooks";
import {
  CompassOutlined,
  ScheduleOutlined,
  ToolOutlined,
  SolutionOutlined
} from "@ant-design/icons";

const style: React.CSSProperties = { background: "#ffffff", padding: "20px", borderRadius: 4 };

const Home = () => {
  const [triggerGetDashboardCount, { data: dashboardData }] = useLazyDashboardCountsQuery();
  const auth = useAppSelector<any>((store) => store.auth);
  const user = auth.user;
  const isAdminUser = user?.roles?.some((role: { role_type: string }) =>
    ["super_user", "mis", "management"].includes(role.role_type)
  );

  useEffect(() => {
    if (isAdminUser && !dashboardData) {
      triggerGetDashboardCount();
    }
  }, [isAdminUser]);

  return (
    <div>
      <h2>Dashboard</h2>
      {isAdminUser && (
        <>
          <br />
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" span={6}>
              <div style={style}>
                <div style={{ display: "flex", alignContent: "center", gap: 10 }}>
                  <ScheduleOutlined style={{ fontSize: "36px", color: "#008c3c" }} />
                  <h2>Bookings</h2>
                </div>
                <h3>{dashboardData?.total_bookings || 0}</h3>
              </div>
            </Col>
            <Col className="gutter-row" span={6}>
              <div style={style}>
                <div style={{ display: "flex", alignContent: "center", gap: 10 }}>
                  <ScheduleOutlined style={{ fontSize: "36px", color: "#008c3c" }} />
                  <h3>Un Assigned Bookings</h3>
                </div>

                <h3>{dashboardData?.total_unassigned_bookings || 0 || 0}</h3>
              </div>
            </Col>
            <Col className="gutter-row" span={6}>
              <div style={style}>
                <div style={{ display: "flex", alignContent: "center", gap: 10 }}>
                  <SolutionOutlined style={{ fontSize: "36px", color: "#008c3c" }} />
                  <h3>Surveys</h3>
                </div>

                <h3>{dashboardData?.total_surveys || 0}</h3>
              </div>
            </Col>
            <Col className="gutter-row" span={6}>
              <div style={style}>
                <div style={{ display: "flex", alignContent: "center", gap: 10 }}>
                  <ToolOutlined style={{ fontSize: "36px", color: "#008c3c" }} />
                  <h3>Installation</h3>
                </div>
                <h3>{dashboardData?.total_installations || 0}</h3>
              </div>
            </Col>
          </Row>
          <br />
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" span={6}>
              <div style={style}>
                <div style={{ display: "flex", alignContent: "center", gap: 10 }}>
                  <CompassOutlined style={{ fontSize: "36px", color: "#008c3c" }} />
                  <h3>Brands</h3>
                </div>
                <h3>{dashboardData?.total_brands || 0}</h3>
              </div>
            </Col>
          </Row>
        </>
      )}
      <br />
      <ReportDownloadForm />
    </div>
  );
};

export default Home;
